import { ACTION_ALLOW, ROLE } from "./constant";

const { isEdit } = ACTION_ALLOW;

const {
  ADMIN,
  HO_STAFF,
  HO_BO,
  HO_REVIEWER,
  SA_EXTERNAL_STAFF,
  SA_EXTERNAL_BO,
  SA_EXTERNAL_REVIEWER,
  AGENT_EXTERNAL,
  AGENT_IN_SHOP_EXTERNAL,
  AGENT_KEY_EXTERNAL,
  MD_EXTERNAL_STAFF,
  MD_EXTERNAL_REVIEWER,
  MD_EXTERNAL_BO,
} = ROLE;

export const roleActionDetailChannel = {
  [ADMIN]: { isEdit },
  [HO_STAFF]: { isEdit },
  [HO_BO]: { isEdit },
  [HO_REVIEWER]: { isEdit },
  [SA_EXTERNAL_STAFF]: { isEdit },
  [SA_EXTERNAL_BO]: { isEdit },
  [SA_EXTERNAL_REVIEWER]: { isEdit },
  [MD_EXTERNAL_STAFF]: { isEdit },
  [MD_EXTERNAL_REVIEWER]: { isEdit },
  [MD_EXTERNAL_BO]: { isEdit },
};

export const roleCancelCreateRequest = {
  [ADMIN]: { ...ACTION_ALLOW },
  [SA_EXTERNAL_STAFF]: { ...ACTION_ALLOW },
  [HO_BO]: { ...ACTION_ALLOW },
  [HO_STAFF]: { ...ACTION_ALLOW },
  [HO_REVIEWER]: { ...ACTION_ALLOW },
};

export const roleWithdraw_Create = {
  [ADMIN]: {},
  [HO_BO]: {},
  [SA_EXTERNAL_BO]: {},
  [MD_EXTERNAL_BO]: {},
  [AGENT_KEY_EXTERNAL]: {},
};

export const roleWithdraw_Review = {
  [ADMIN]: {},
  [HO_REVIEWER]: {},
  [SA_EXTERNAL_REVIEWER]: {},
  [MD_EXTERNAL_REVIEWER]: {},
};

export const roleWithdraw_Approve = {
  [ADMIN]: {},
  [HO_BO]: {},
  [SA_EXTERNAL_BO]: {},
  [MD_EXTERNAL_BO]: {},
};

export const roleSysUser = {
  [ADMIN]: {},
  [HO_STAFF]: {},
  [HO_BO]: {},
  [HO_REVIEWER]: {},
  [MD_EXTERNAL_BO]: {},
  [MD_EXTERNAL_REVIEWER]: {},
  [MD_EXTERNAL_STAFF]: {},
  [SA_EXTERNAL_BO]: {},
  [SA_EXTERNAL_STAFF]: {},
  [SA_EXTERNAL_REVIEWER]: {},
};

export const roleCashinRequest = {
  [ADMIN]: {},
  [HO_BO]: {},
  [HO_STAFF]: {},
  [SA_EXTERNAL_BO]: {},
  [SA_EXTERNAL_STAFF]: {},
  [MD_EXTERNAL_BO]: {},
  [MD_EXTERNAL_STAFF]: {},
};

export const roleCashinApprove = {
  [ADMIN]: {},
  [HO_BO]: {},
  [SA_EXTERNAL_BO]: {},
  [MD_EXTERNAL_BO]: {},
};

export const roleFundingCreate = {
  [ADMIN]: {},
  [SA_EXTERNAL_BO]: {},
  [MD_EXTERNAL_BO]: {},
  [AGENT_KEY_EXTERNAL]: {},
};

export const roleFundingReview = {
  [ADMIN]: {},
  [SA_EXTERNAL_REVIEWER]: {},
  [MD_EXTERNAL_REVIEWER]: {},
  [HO_REVIEWER]: {},
};

export const roleFundingApprove = {
  [ADMIN]: {},
  [SA_EXTERNAL_BO]: {},
  [MD_EXTERNAL_BO]: {},
  [HO_BO]: {},
};

export const roleTransactionHistory = {
  [ADMIN]: {},
  [HO_STAFF]: {},
  [HO_BO]: {},
  [HO_REVIEWER]: {},
  [SA_EXTERNAL_BO]: {},
  [SA_EXTERNAL_STAFF]: {},
  [SA_EXTERNAL_REVIEWER]: {},
  [AGENT_EXTERNAL]: {},
  [AGENT_KEY_EXTERNAL]: {},
  [AGENT_IN_SHOP_EXTERNAL]: {},
  [MD_EXTERNAL_BO]: {},
  [MD_EXTERNAL_STAFF]: {},
  [MD_EXTERNAL_REVIEWER]: {},
};

export const roleFundingRequest = {
  [ADMIN]: {},
  [SA_EXTERNAL_BO]: {},
  [MD_EXTERNAL_BO]: {},
  [AGENT_KEY_EXTERNAL]: {},
};
export const rolePaymentReview = {
  [ADMIN]: {},
  [SA_EXTERNAL_REVIEWER]: {},
  [MD_EXTERNAL_REVIEWER]: {},
  [SA_EXTERNAL_BO]: {},
  [SA_EXTERNAL_STAFF]: {},
  [SA_EXTERNAL_REVIEWER]: {},
  [MD_EXTERNAL_BO]: {},
  [MD_EXTERNAL_STAFF]: {},
  [MD_EXTERNAL_REVIEWER]: {},
};
